const settingsConfig = {
	layout: {
		style: 'layout1', // layout-1 layout-2 layout-3
		config: {} // checkout default layout configs at app/fuse-layouts for example  app/fuse-layouts/layout1/Layout1Config.js
	},
	/* Commenting the following code for POW-789. Harsha using AI Agent. February 25, 2026. Comment Start */
	/* customScrollbars: true, */
	/* Commenting end. Harsha using AI Agent. February 25, 2026 */
	/* Added the following code for POW-789. Harsha using AI Agent. February 25, 2026. Code Start */
	/**
	 * Disabled PerfectScrollbar (custom scrollbars) globally to fix trackpad/two-finger scroll
	 * not working reliably on pages with nested scroll containers (e.g., ManageJob candidate tables).
	 * Native browser scrolling is styled via ::-webkit-scrollbar rules in index.css.
	 */
	customScrollbars: false,
	/* Code end. Harsha using AI Agent. February 25, 2026 */
	animations: true,
	direction: 'ltr', // rtl, ltr
	theme: {
		main: 'default',
		navbar: 'default',
		toolbar: 'mainThemeLight',
		footer: 'mainThemeDark'
	}
};

export default settingsConfig;
